<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Mijozlar Bazasi") }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <!-- Sotuv turi filter -->
          <div class="sale-type-filter">
            <button :class="['filter-btn', { active: saleTypeFilter === '' }]" @click="saleTypeFilter = ''">
              {{ $t("Barchasi") }}
            </button>
            <button :class="['filter-btn', { active: saleTypeFilter === 'chakana' }]" @click="saleTypeFilter = 'chakana'">
              {{ $t("Chakana") }}
            </button>
            <button :class="['filter-btn', { active: saleTypeFilter === 'optom' }]" @click="saleTypeFilter = 'optom'">
              {{ $t("Optom") }}
            </button>
          </div>

          <!-- Qarz muddati alerts BADGE -->
          <button
            class="debt-alert-btn"
            v-if="(debtAlerts.overdue_count + debtAlerts.upcoming_count) > 0"
            @click="openDebtModal"
            :title="$t('Qarz muddati ogohlantirishlari')"
          >
            <b-icon icon="bell-fill"></b-icon>
            <span v-if="debtAlerts.overdue_count > 0" class="debt-alert-pip overdue">{{ debtAlerts.overdue_count }}</span>
            <span v-else-if="debtAlerts.upcoming_count > 0" class="debt-alert-pip upcoming">{{ debtAlerts.upcoming_count }}</span>
          </button>

          <!-- Refresh tugmasi -->
          <button class="refresh-btn" @click="Data(parent)" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <!-- Qo'shish tugmasi (Gradient) -->
          <button class="add-btn" @click="$router.push('/malumot/kontragent/create')" v-if="rule.change">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
          </button>

          <top></top>
        </div>
      </div>

      <!-- QARZ MUDDATI MODAL (2 ta tab) -->
      <div v-if="showDebtModal" class="dbt-overlay" @click.self="showDebtModal = false">
        <div class="dbt-modal">
          <div class="dbt-header">
            <h3 class="dbt-title">
              <b-icon icon="bell-fill" class="mr-2"></b-icon>
              {{ $t("Qarz muddati ogohlantirishlari") }}
            </h3>
            <button class="dbt-close" @click="showDebtModal = false">&times;</button>
          </div>

          <!-- Tab nav -->
          <div class="dbt-tabs">
            <button
              :class="['dbt-tab', { active: debtTab === 'overdue' }]"
              @click="debtTab = 'overdue'"
            >
              <b-icon icon="exclamation-triangle-fill"></b-icon>
              <span>{{ $t("Muddati o'tgan") }}</span>
              <span class="dbt-tab-pip overdue">{{ debtAlerts.overdue.length }}</span>
            </button>
            <button
              :class="['dbt-tab', { active: debtTab === 'upcoming' }]"
              @click="debtTab = 'upcoming'"
            >
              <b-icon icon="clock-fill"></b-icon>
              <span>{{ $t("Muddati yaqin") }} ({{ alertDays }} kun)</span>
              <span class="dbt-tab-pip upcoming">{{ debtAlerts.upcoming.length }}</span>
            </button>
          </div>

          <!-- Tab content -->
          <div class="dbt-body">
            <div v-if="currentDebtList.length === 0" class="dbt-empty">
              <b-icon icon="check-circle" font-scale="2.5" variant="success"></b-icon>
              <p class="mt-2">{{ debtTab === 'overdue' ? $t("Muddati o'tgan qarzdorlar yo'q") : $t("Yaqin muddatli qarzdorlar yo'q") }}</p>
            </div>

            <div v-else>
              <div v-for="(c, i) in currentDebtList" :key="(c.kontragent_id || i)" class="dbt-row" @click="goToClient(c)">
                <div class="dbt-row-main">
                  <div class="dbt-name">
                    <span class="dbt-rank">#{{ i + 1 }}</span>
                    <b>{{ c.kontragent_name || "NOMA'LUM" }}</b>
                  </div>
                  <div class="dbt-phone">
                    <b-icon icon="telephone-fill"></b-icon>
                    {{ c.phone_number || '—' }}
                  </div>
                </div>
                <div class="dbt-row-meta">
                  <div class="dbt-summa">
                    <span class="dbt-summa-label">Qarzi:</span>
                    <b>{{ fmtMoney(c.total_debt) }} so'm</b>
                  </div>
                  <div :class="['dbt-due', debtTab === 'overdue' ? 'overdue' : 'upcoming']">
                    <b-icon icon="calendar-event"></b-icon>
                    {{ fmtDate(c.earliest_due) }}
                    <small v-if="debtTab === 'overdue'">({{ daysAgo(c.earliest_due) }} kun avval)</small>
                    <small v-else>({{ daysLeft(c.earliest_due) }} kun qoldi)</small>
                  </div>
                </div>
                <div class="dbt-sales-count">
                  <b-icon icon="receipt"></b-icon> {{ c.sales.length }} savdo
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MIJOZ TURI TABLARI -->
      <div class="client-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['client-tab', { active: typeTab === tab.value }]"
          @click="setTab(tab.value)"
        >
          <b-icon :icon="tab.icon" class="mr-2"></b-icon>
          {{ tab.label }}
          <span class="tab-count">{{ counts[tab.value] || 0 }}</span>
        </button>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th>{{ $t('MIJOZ') }}</th>
                <th>{{ $t('TEL') }}</th>
                <th>{{ $t('CAR / MANZIL') }}</th>
                <th style="width: 120px; text-align: center;">{{ $t('SOTUV TURI') }}</th>
                <th style="width: 120px; text-align: center;">{{ $t('STATUS') }}</th>
                <th style="width: 120px; text-align: center;">{{ $t('AMALLAR') }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Orqaga qaytish (Folderlar uchun) -->
              <tr v-if="parent !== 0" class="navigation-row" @dblclick="Data(parent)">
                <td><b-icon icon="arrow-left-circle-fill" variant="secondary"></b-icon></td>
                <td colspan="6" class="text-muted italic">.. (Orqaga qaytish)</td>
              </tr>

              <!-- Ma'lumotlar -->
              <tr v-for="(item, index) in filteredRows" :key="item.id" :class="{ 'folder-row': item.is_folder }"
                @dblclick="Selectkontragent(item)">
                <td>
                  <b-icon v-if="item.is_folder" icon="folder-fill" variant="warning" font-scale="1.2"></b-icon>
                  <span v-else class="id-badge">#{{ index + 1 }}</span>
                </td>
                <td class="font-bold">{{ item.name }}</td>
                <td>{{ item.phone_number || '—' }}</td>
                <td><span class="text-muted small">{{ item.address || '—' }}</span></td>
                <td class="text-center">
                  <span :class="['sale-type-badge', item.sale_type === 'optom' ? 'optom' : 'chakana']">
                    {{ item.sale_type === 'optom' ? $t('Optom') : $t('Chakana') }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="status-badge">Faol</span>
                </td>
                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click="$router.push('/malumot/kontragent/update/' + item.id)">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="7" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER (Pagination ma'lumoti) -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ filteredRows.length }}</b> ta mijoz
          </div>
          <div class="text-muted small italic" v-if="parent !== 0">
            * Papka ichida ochilgan
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from "../../Layout/Top.vue";

export default {
  components: { Top },
  data() {
    return {
      filter: "",
      saleTypeFilter: "",
      typeTab: 1,
      parent: 0,
      list: [],
      counts: { 1: 0, 2: 0, 3: 0 },
      rule: { change: true },
      tabs: [
        { value: 1, label: "Oddiy mijoz", icon: "person-fill" },
        { value: 2, label: "Usta mijoz", icon: "tools" },
        { value: 3, label: "Zapchas mijoz", icon: "gear-fill" }
      ],
      // Qarz muddati ogohlantirishlari
      debtAlerts: { overdue: [], upcoming: [], overdue_count: 0, upcoming_count: 0 },
      alertDays: 3,
      showDebtModal: false,
      debtTab: 'overdue',
    };
  },
  computed: {
    filteredRows() {
      let rows = this.list;
      if (this.saleTypeFilter) {
        rows = rows.filter(row => row.sale_type === this.saleTypeFilter);
      }
      if (this.filter.length > 1) {
        rows = rows.filter(row =>
          row.name.toLowerCase().includes(this.filter.toLowerCase()) ||
          (row.phone_number && row.phone_number.includes(this.filter))
        );
      }
      return rows;
    },
    currentDebtList() {
      return this.debtTab === 'overdue' ? this.debtAlerts.overdue : this.debtAlerts.upcoming;
    }
  },
  mounted() {
    this.Data(0);
    this.refreshCounts();
    this.loadDebtAlerts();
    // Har 5 daqiqada qarz alertlarini yangilash
    this._alertTimer = setInterval(() => this.loadDebtAlerts(), 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this._alertTimer) clearInterval(this._alertTimer);
  },
  methods: {
    Data(parent) {
      axios.get("api/v1/kontragent/type/" + this.typeTab).then(res => {
        this.list = res.data || [];
      });
    },
    setTab(value) {
      this.typeTab = value;
      this.Data(this.parent);
    },
    refreshCounts() {
      // Har bir tab uchun mijozlar sonini olish (parallel)
      [1, 2, 3].forEach(t => {
        axios.get("api/v1/kontragent/type/" + t).then(res => {
          this.$set(this.counts, t, (res.data || []).length);
        }).catch(() => {});
      });
    },
    Selectkontragent(item) {
      if (!item.is_folder) {
        this.$router.push({ path: '/malumot/kontragent/update/' + item.id });
      } else {
        this.Data(item.id);
      }
    },
    Trash(id) {
      if (!confirm("Haqiqatan ham bu mijozni o'chirmoqchimisiz?")) return;
      axios.delete("api/v1/kontragent/id/" + id).then(() => {
        this.Data(this.parent);
        this.refreshCounts();
      }).catch(err => {
        console.error("O'chirishda xato:", err);
        alert("O'chirishda xatolik yuz berdi");
      });
    },

    // ============ QARZ MUDDATI OGOHLANTIRISHLARI ============
    loadDebtAlerts() {
      axios.get(`api/v1/report/debt-alerts/?days=${this.alertDays}`).then(res => {
        this.debtAlerts = res.data || { overdue: [], upcoming: [], overdue_count: 0, upcoming_count: 0 };
      }).catch(() => {
        this.debtAlerts = { overdue: [], upcoming: [], overdue_count: 0, upcoming_count: 0 };
      });
    },
    openDebtModal() {
      // Avtomatik tanlash: agar overdue bor bo'lsa shuni ko'rsatamiz, aks holda upcoming
      this.debtTab = this.debtAlerts.overdue.length > 0 ? 'overdue' : 'upcoming';
      this.showDebtModal = true;
    },
    goToClient(c) {
      if (!c.kontragent_id) return;
      this.showDebtModal = false;
      // Mijoz ma'lumotini tahrirlash emas — Nasiyalar sahifasidagi "Oldi-berdi
      // tarixi" oynasini ochamiz (qarzni tekshirish uchun shu kerak).
      this.$router.push({ path: '/nasiyalar', query: { kontragent_id: c.kontragent_id } });
    },
    fmtMoney(v) {
      return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 0 }).replace(/,/g, ' ');
    },
    fmtDate(ts) {
      if (!ts) return '—';
      const d = new Date(Number(ts) * 1000);
      return d.toLocaleDateString('ru-RU');
    },
    daysAgo(ts) {
      if (!ts) return 0;
      const diff = Math.floor((Date.now() / 1000 - Number(ts)) / 86400);
      return Math.max(0, diff);
    },
    daysLeft(ts) {
      if (!ts) return 0;
      const diff = Math.ceil((Number(ts) - Date.now() / 1000) / 86400);
      return Math.max(0, diff);
    },
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH INPUT */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

/* Folder ko'rinishi */
.folder-row {
  background-color: #fffbeb;
  cursor: pointer;
}

.folder-row:hover {
  background-color: #fef3c7;
}

.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
}

/* ID & Status badges */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.status-badge {
  background: #f0fdf4;
  color: #16a34a;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #dcfce7;
}

.font-bold {
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px;
  color: #94a3b8;
  font-style: italic;
}

/* SALE TYPE FILTER */
.sale-type-filter {
  display: flex;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
}

.filter-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}

.filter-btn.active {
  background: #a142f4;
  color: white;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.25);
}

/* SALE TYPE BADGE */
.sale-type-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}

.sale-type-badge.chakana {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
}

.sale-type-badge.optom {
  background: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}

/* MIJOZ TURI TABLARI */
.client-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  background: white;
  padding: 6px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.02);
}

.client-tab {
  flex: 1;
  background: transparent;
  border: none;
  padding: 12px 18px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.25s;
  position: relative;
}

.client-tab:hover:not(.active) {
  background: #f8fafc;
  color: #a142f4;
}

.client-tab.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  box-shadow: 0 6px 18px rgba(161, 66, 244, 0.25);
}

.tab-count {
  background: rgba(255, 255, 255, 0.25);
  color: inherit;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  margin-left: 8px;
  min-width: 26px;
  text-align: center;
}

.client-tab:not(.active) .tab-count {
  background: #f1f5f9;
  color: #94a3b8;
}

/* ============ QARZ MUDDATI BADGE va MODAL ============ */
.debt-alert-btn {
  position: relative;
  background: white;
  border: 1.5px solid #e2e8f0;
  color: #f59e0b;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  font-size: 18px;
}
.debt-alert-btn:hover {
  border-color: #f59e0b;
  background: #fffbeb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
}
.debt-alert-pip {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  color: white;
  padding: 0 6px;
  border: 2px solid white;
}
.debt-alert-pip.overdue {
  background: #e11d48;
  animation: alert-pulse 1.5s ease-in-out infinite;
}
.debt-alert-pip.upcoming {
  background: #f59e0b;
}
@keyframes alert-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.5); }
  50% { box-shadow: 0 0 0 6px rgba(225, 29, 72, 0); }
}

/* Modal */
.dbt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.dbt-modal {
  background: white;
  width: 680px;
  max-width: 100%;
  max-height: 85vh;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: dbt-pop 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes dbt-pop {
  0% { transform: scale(0.92); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
.dbt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
}
.dbt-title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #92400e;
  display: flex;
  align-items: center;
}
.dbt-close {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: white;
  color: #64748b;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dbt-close:hover { background: #fee2e2; color: #e11d48; }

.dbt-tabs {
  display: flex;
  gap: 6px;
  padding: 10px 18px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}
.dbt-tab {
  flex: 1;
  background: transparent;
  border: none;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: 0.2s;
}
.dbt-tab:hover { background: #f1f5f9; }
.dbt-tab.active {
  background: white;
  color: #0f172a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.dbt-tab-pip {
  background: #cbd5e1;
  color: white;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  min-width: 22px;
  text-align: center;
}
.dbt-tab-pip.overdue { background: #e11d48; }
.dbt-tab-pip.upcoming { background: #f59e0b; }

.dbt-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 18px;
}
.dbt-empty {
  text-align: center;
  padding: 50px 20px;
  color: #94a3b8;
  font-style: italic;
}

.dbt-row {
  display: grid;
  grid-template-columns: 1.6fr 1.2fr auto;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fafc;
  margin-bottom: 8px;
  cursor: pointer;
  transition: 0.15s;
  border-left: 3px solid transparent;
}
.dbt-row:hover {
  background: #fef3c7;
  transform: translateX(2px);
  border-left-color: #f59e0b;
}
.dbt-row-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.dbt-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #0f172a;
}
.dbt-rank {
  background: #cbd5e1;
  color: white;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
}
.dbt-phone {
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
}
.dbt-row-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dbt-summa {
  font-size: 14px;
  color: #0f172a;
}
.dbt-summa-label {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 4px;
}
.dbt-due {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  width: fit-content;
}
.dbt-due.overdue {
  background: #fee2e2;
  color: #b91c1c;
}
.dbt-due.upcoming {
  background: #fef3c7;
  color: #b45309;
}
.dbt-due small {
  margin-left: 4px;
  opacity: 0.8;
  font-weight: 500;
}
.dbt-sales-count {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
</style>